<template>
    <div>
        <div class="vld-parent">
            <loading :active.sync="open_loader"
                     :can-cancel="false"
                     :is-full-page="true">
            </loading>
        </div>

        <breadcrumbs
            :title="'Izvještaji'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox ">
            <div class="ibox-title">
                <h5></h5>
            </div>

            <div class="ibox">
                <div class="ibox-title">
                    <h5>Izvještaj</h5>
                </div>
                <div class="ibox-content">
                    <forms
                        :settings="form_settings"
                        @onInput="onInput"
                        @onFormButtonClick="onFormButtonClick"
                    >
                    </forms>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs";
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import Forms from "../../../components/form/Forms";
import axios from "axios";
import toastr from "toastr";

export default {
    name: "IzvjestajiHKIE",
    components: {
        Breadcrumbs,
        Loading,
        Forms
    },

    data(){
        return {
            open_loader: false,
            breadcrumbs: [],
            form_settings: {},

            // inputs
            izvjestaj_select: [
                {
                    key: 1,
                    value: "Ispis bodova"
                },
            ],

            grupa_statusa_select:[],

            datum_od: '',
            datum_do: '',
            izvjestaj: {key: '', value:''},
            grupa_statusa: {key: '', value: ''}
        }
    },

    methods:{

        fetchGrupaStatus(){
            let vm = this;
            axios.get( process.env.VUE_APP_API_URL +  'grupa-statusa' )
                .then( function ( response ) {
                    response.data.data.forEach( function ( item ) {
                        vm.grupa_statusa_select.push({
                            key: item.id,
                            value: item.naziv
                        })
                    } );
                } )
                .catch( function ( error ) {
                    if(error instanceof Error) {
                        console.log( 'Error: ' . error);
                    } else {
                        console.log( 'Unexpected response: ' . error);
                    }
                } )
        },

        getGrupaStatusa( id ){
            return this.grupa_statusa_select.find( item => item.key === id );
        },

        setup_form(){
            let vm = this

            let buttons = []

            if( vm.izvjestaj.key ){
                buttons.push({
                    id: 'download',
                    title: 'Preuzmi',
                    type: 'primary',
                    action: 'download',
                })
            }

            let inputs = []

            let izvjestaj_select = {
                name: 'izvjestaj_id',
                type: 'select',
                title: 'Izvještaj',
                value: vm.izvjestaj,
                error: '',
                width: 12,
                config: {
                    options: vm.izvjestaj_select,
                    multiple: false,
                    title_width: 2,
                    input_width: 10
                }
            }
            inputs.push( izvjestaj_select )


            console.log( vm.izvjestaj.key )
            // select datumi
            if( [1].includes( vm.izvjestaj.key ) ){

                let datum_od_input = {
                    name: 'datum_od',
                    type: 'datepicker',
                    title: 'Datum od',
                    value: vm.datum_od,
                    width: 6,
                    error: '',
                    note: '',
                    explanation: '',
                    placeholder: '',
                    required: !vm.disabled,
                    readonly: vm.disabled,
                    disabled: vm.disabled,
                    config: {
                        mode: 'date',
                        title_width: 4,
                        input_width: 8
                    }
                }

                let datum_do_input = {
                    name: 'datum_do',
                    type: 'datepicker',
                    title: 'Datum do',
                    value: vm.datum_do,
                    width: 6,
                    error: '',
                    note: '',
                    explanation: '',
                    placeholder: '',
                    required: !vm.disabled,
                    readonly: vm.disabled,
                    disabled: vm.disabled,
                    config: {
                        mode: 'date',
                        title_width: 4,
                        input_width: 8
                    }
                }

                let grupa_statusa_input = {
                    name: 'grupa_statusa_id',
                    type: 'select',
                    title: 'Grupa statusa',
                    value: vm.grupa_statusa,
                    width: 6,
                    error: '',
                    note: '',
                    explanation: '',
                    placeholder: '',
                    required: false,
                    readonly: vm.disabled,
                    disabled: vm.disabled,
                    config: {
                        options: vm.grupa_statusa_select,
                        title_width: 4,
                        input_width: 8
                    }
                }

                inputs.push( datum_od_input )
                inputs.push( datum_do_input )
                inputs.push( grupa_statusa_input )
            }





            let settings = {
                width: 6,
                modal: false,
                tabs:[
                    {
                        name: '',
                        active: true,
                        sections: [
                            {
                                name: '',
                                width: 12,
                                inputs: inputs,
                            }
                        ],
                    },
                ],
                buttons: buttons
            }

            vm.form_settings = settings
        },

        onInput( name, value ){
            let vm = this
            if( name === 'izvjestaj_id' && value !== vm.izvjestaj.key  ){
                if( value )
                    vm.izvjestaj = vm.izvjestaj_select.find( item => item.key === value )
                else {
                    vm.izvjestaj = { key: '', value: '' }
                    vm.datum_od = ''
                    vm.datum_do = ''
                    vm.izvjestaj = { key: '', value: '' }

                }
                this.setup_form()
            } else if ( value ) {
                if( name === 'datum_od' ){
                    vm.datum_od = value
                } else if( name === 'datum_do' ){
                    vm.datum_do = value
                } else if ( name = 'grupa_statusa_id' ){
                    vm.grupa_statusa = vm.getGrupaStatusa( value )
                }
                this.setup_form()
            }
        },


        onFormButtonClick( id, action, config, data ){
            let vm = this
            vm.open_loader = true
            axios({
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + 'izvjestaj-hkie/' + vm.izvjestaj.key,
                    data: data,
                    responseType: 'blob'
                }
            ).then((response) => {
                vm.open_loader = false
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(
                    new Blob([response.data]),
                    {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                );
                link.setAttribute('download', vm.izvjestaj.value + '.xlsx');
                document.body.appendChild(link);
                link.click();
            }, (error) => {
                vm.open_loader = false
                console.log(error);
                toastr.error( error.toString() )
            });
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/izvještaji',
                    name: 'Izvještaji'
                }
            ];
        }
    },

    mounted() {
        this.setBreadcrumbs()
        this.fetchGrupaStatus()
        this.setup_form()
    }
};
</script>

<style scoped>

</style>
